var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"9","viewBox":"0 0 16 9"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#4A9BF9","stroke-linecap":"round"}},[_c('path',{attrs:{"d":"M.533 3.733L15.467 3.733M11.2.533L15.467 3.733M15.467 3.733L11.2 6.933","transform":"rotate(-180 8 4.233)"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }